import * as _ from 'lodash';
import { BaseModel } from '../common-models/base-model';
import { IMunicipalityModel } from 'src/app/interfaces/municipality-model.interface';
import { GAPIDataSourceCategory } from 'src/shared/enums/data-source-category-enum';

export class MunicipalityModel extends BaseModel implements IMunicipalityModel {
    Id: number;
    Name: string;
    Description: string;
    State: string;
    UsePosition: number;
    Latitude: number;
    Longitude: number;
    GridicsInstanceId: number;
    ZoomLevel: number;
    LogoPath: string;
    Tiles3DURL: string;
    Tiles3DAccessToken: string;
    GridicsId: string;
    ProjectsDataSourceCategory: number;
    IndexStateLayerPRs: boolean;
    importValidationResult?: any;

    parcelLevel?: GAPIDataSourceCategory;
}
